<div class="flex flex-col h-full">
	<div class="flex h-full min-h-0 flex-1 overflow-auto">
		<div class="w-1/6 flex flex-col mr-3">
			<app-radio-group
				*ngIf="primaryPinList.length"
				label="Primary PIN"
				[required]="true"
				orientation="vertical"
				[items]="primaryPinList"
				[ngModel]="selectedPrimaryPinId"
				(ngModelChange)="onSelectPrimarySearchItem($event)"
			></app-radio-group>

			<div class="my-2" *ngIf="adjacentPinList.length">
				<label
					(click)="showAdjacent()"
					class="text-green hover:underline cursor-pointer"
				>
					{{ showAdjacentPins ? 'Hide' : 'Show' }} adjacent PINs
				</label>
			</div>

			<app-radio-group
				*ngIf="showAdjacentPins"
				orientation="vertical"
				[items]="adjacentPinList"
				[ngModel]="selectedAdjacentPinId"
				(ngModelChange)="onSelectAdjacentSearchItem($event)"
			></app-radio-group>
		</div>

		<div class="w-5/6">
			<table
				class="dashboard-table rounded-xl border border-grey-lightest w-full"
			>
				<thead class="sticky top-0 bg-white">
					<tr>
						<th>No.</th>
						<th>Date</th>
						<th>Type</th>
						<th>Parties to</th>
						<th>Parties from</th>
						<th>Amount</th>
					</tr>
				</thead>
				<tbody class="text-base">
					<tr
						*ngFor="let instrument of instruments; trackBy: instrumentId"
						(click)="onRowClick(instrument)"
						[ngClass]="{
							'bg-green-lighter':
								selectedInstrument?.reg_number === instrument?.reg_number,
							'cursor-pointer': true,
						}"
					>
						<td>{{ instrument?.reg_number }}</td>
						<td>{{ instrument?.reg_date }}</td>
						<td>{{ instrument?.type }}</td>
						<td>
							<span
								*ngFor="let from of instrument.parties_from; index as i"
								class="mr-3 capitalize"
							>
								{{ from }}
							</span>
						</td>
						<td>
							<span
								*ngFor="let to of instrument.parties_to; index as i"
								class="mr-3 capitalize"
							>
								{{ to }}
							</span>
						</td>
						<td>
							{{ instrument?.amount }}
						</td>
					</tr>

					<tr *ngIf="!instruments">
						No instruments found.
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<div class="flex justify-between mt-2">
		<app-button btn="tertiary" size="small" (click)="closeModal()"
			>Cancel</app-button
		>
		<app-button
			size="small"
			(click)="createRequisition()"
			[disabled]="!selectedInstrument"
			>Create requisition</app-button
		>
	</div>
</div>
